
// TEMP_BRIDGE
module.exports = require("./PageWrap" + ".tsx");

